define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"SiteAdmin/AttributeMap/MappedAttributeId"
], function(declare,_,MappedAttributeId) {

	return declare(MappedAttributeId, {

		sourceClassName: null,
		destinationClassNames: ["Style", "StyleAttributes", "StyleSourcing", "StyleSpecification"],

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			return value.replace(":", ": ");
		},

		_getDestAttrName: function(destAttr) {
			// summary: return the attribute's display name for the drop-down
			return destAttr.getOwner().getType() + ": " + destAttr.getId();
		},

		_getDestAttrId: function(destAttr) {
			// summary: return the attribute's value for the drop-down
			return destAttr.getOwner().getType() + ":" + destAttr.getId();
		}
	});
});
